import * as actionTypes from './actionTypes';

export const getOffers = () => ({
  type: actionTypes.GET_OFFERS_REQUEST,
  requestType: 'GET',
  successType: actionTypes.GET_OFFERS_SUCCESS,
  errorType: actionTypes.GET_OFFERS_ERROR,
  url: '/plans/offers',
});
